import { render, staticRenderFns } from "./VCA_EnemyAI.vue?vue&type=template&id=f12b67f6&scoped=true&"
import script from "./VCA_EnemyAI.vue?vue&type=script&lang=ts&"
export * from "./VCA_EnemyAI.vue?vue&type=script&lang=ts&"
import style0 from "./VCA_EnemyAI.vue?vue&type=style&index=0&id=f12b67f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12b67f6",
  null
  
)

export default component.exports